// @flow
import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import { FormControlLabel } from "@material-ui/core";
import type { FieldProps } from "redux-form";

const RFCheckbox = ({ input, meta: { touched, error } }: FieldProps) => (
    <FormControl fullWidth error={!!(touched && error)}>
        <FormControlLabel
            key="RGPD"
            label={
                <>
                    J’ai lu et accepte la &nbsp;
                    <a href="/mentions-legales/" target="blank">
                        politique de protection des données personnelles
                    </a>
                    &nbsp; de Patrimoine-Environnement
                </>
            }
            control={
                <Checkbox
                    className="form__checkbox"
                    name="rgpd"
                    value="rgpd"
                    onChange={(event, checked) => input.onChange(checked)}
                />
            }
        />
        {touched && error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
);
export default RFCheckbox;
